export const clean = function(){
  const language = sessionStorage.getItem('language')
  const maxUploadSize = sessionStorage.getItem('max_upload_size')
  const pageSize = sessionStorage.getItem('page_size')
  const imageType = sessionStorage.getItem('image_type')
  const currency = sessionStorage.getItem('currency')
  const baseurl = sessionStorage.getItem('baseurl')
  sessionStorage.clear()
  sessionStorage.setItem('language',language)
  sessionStorage.setItem('max_upload_size',maxUploadSize)
  sessionStorage.setItem('page_size',pageSize)
  sessionStorage.setItem('image_type',imageType)
  sessionStorage.setItem('currency',currency)
  sessionStorage.setItem('baseurl',baseurl)
}